import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { SaleItemFileFragment } from 'graphql/SaleItemFile/fragments/SaleItemFileFragment';
import { SaleItemGroupFragment } from 'graphql/SaleItemGroup/fragments/SaleItemGroupFragment';
import { SaleItemImageFragment } from 'graphql/SaleItemImage/fragments/SaleItemImageFragment';
import { TaxFragment } from 'graphql/Tax/fragments/TaxFragment';
/**
 * @fragment DealItemSaleItemMinimalFragment
 * @since 1.0.0
 *
 * Lightweight sale item fragment for deal configure screen.
 * Full catalog details are available via SaleItemQuery lazy-load.
 */
export const DealItemSaleItemMinimalFragment = gql `
  fragment DealItemSaleItemMinimalFragment on SaleItem {
    id
    sku
    price
    cost
    category
    configuration
    optionConfiguration
    active
    promoted
    taxable
    unitOfMeasurement
    quantityCalculation
    title
    summary
    infos
    deletedAt

    translations {
      title
      summary
      infos

      language {
        ...LanguageFragment
      }
    }

    taxes {
      ...TaxFragment
    }

    group {
      ...SaleItemGroupFragment
    }

    groups {
      ...SaleItemGroupFragment
    }

    image {
      ...SaleItemImageFragment
    }

    images {
      ...SaleItemImageFragment
    }

    files {
      ...SaleItemFileFragment
    }

    fieldValues {
      value
      field {
        id
        name
        title
        type
        promote
        visibility
        group {
          id
          category
        }
      }
    }

    variants {
      id
      sku
      price
      active
    }

    options {
      id
      price
      quantity
      included
      proposed
      locked
      recommended

      relations {
        id
        type
        quantity
        saleItem {
          id
        }
        relatedSaleItem {
          id
          sku
          title
          active
          price
        }
      }

      item {
        id
        sku
        title
        summary
        infos
        active
        deletedAt

        translations {
          title
          summary
          infos

          language {
            ...LanguageFragment
          }
        }

        image {
          ...SaleItemImageFragment
        }

        group {
          id
          title
          order
          display
          hasUniqueOptionRestriction
          mustHaveOptionSelected
        }

        groups {
          id
          title
          order
          display
          hasUniqueOptionRestriction
          mustHaveOptionSelected
        }

        relations {
          id
          type
          quantity
          saleItem {
            id
          }
          relatedSaleItem {
            id
            sku
            title
            active
            price
          }
        }
      }
    }

    packages {
      id

      package {
        id
        sku
        title
        infos
        price
        active
        icon
        deletedAt

        saleItems {
          id
          required
          item {
            id
            title
          }
        }
      }
    }
  }

  ${SaleItemGroupFragment}
  ${SaleItemImageFragment}
  ${SaleItemFileFragment}
  ${LanguageFragment}
  ${TaxFragment}
`;
